module.exports = __webpack_public_path__ + "img/材料力学8_5_4.5b4c3e18.jpg";